export const HEADER_CELLS = [
    { id: 'tag',        label: 'Tag'},
    { id: 'orderId',    label: 'Order ID'},
    { id: 'status',     label: 'Status'},
    { id: 'notes',      label: 'Notes'},
    { id: 'name',       label: 'Name'},
    { id: 'address',    label: 'Address'},
    { id: 'city',       label: 'City'},
    { id: 'state',      label: 'State'},
    { id: 'sku',        label: 'SKU'},
    { id: 'shipFrom',   label: 'Ship From'},
    { id: 'rate',       label: 'Rate'},
    { id: 'carrier',    label: 'Carrier'},
    { id: 'prime',      label: 'Prime'},
    { id: 'orderDate',  label: 'Order Date'},
    { id: 'shipBy',     label: 'Ship By'},
    { id: 'deliverBy',  label: 'Deliver By'},
    { id: 'marketplace',label: 'Marketplace'},
    { id: 'shipMethod', label: 'Ship Method'},

]


export const SHIPPED_SHIPMENT_QUEUE_HEADER_CELLS = [
    { id: '', label: '', width: '6%'},
    { id: 'orderId', label: 'Order ID', width: '12%', numeric: false},
    { id: 'trackingNumber', label: 'Tracking Number', width: '10%', numeric: false},
    { id: 'carrierName', label: 'Carrier Name', width: '10%', numeric: false},
    { id: 'carrierService', label: 'Carrier Service', width: '10%', numeric: false},
    { id: 'shipDate', label: 'Ship Date', width: '7%', numeric: false},
    { id: 'numOfPackages', label: 'Packages', width: '4%', numeric: false},
    { id: 'orderItems', label: 'Order Items', width: '8%', numeric: false},
    { id: 'marketplace', label: 'Marketplace', width: '6%', numeric: false},
    { id: 'confirmStatus', label: 'Confirm Status', width: '5%', numeric: false},
    { id: 'responseCode', label: 'Response Code', width: '4%', numeric: false},
    { id: 'responseReason', label: 'Response Reason', width: '13%', numeric: false},
    { id: 'retryCount', label: 'Retry Count', width: '4%', numeric: false},
    { id: 'skipped', label: 'Skipped', width: '4%', numeric: false},
    { id: 'skipReason', label: 'Skip Reason', width: '13%', numeric: false},
    { id: 'split', label: 'Split', width: '4%', numeric: false},
    { id: 'voided', label: 'Voided', width: '4%', numeric: false},
    { id: '', label: '', width: '5%'},
]

export const MANUAL_RESOLVE = "Resolve"
export const ARCHIVE_SHIPPED_SHIPMENT_IN_QUEUE = "Archive Shipped Shipment"
export const CONFIRM_SHIPPED_SHIPMENT_IN_QUEUE = "Confirm Shipped Shipment"
export const RECONFIRM_SHIPPED_SHIPMENT = "Retry Confirm Shipment Through "